// create a component with adjustable gaps between atoms

export const Gap = ({ gap }: { gap: number }) => {
    return <div style={{ height: gap + 'px' }} />;
}